<mat-card *ngIf="invoicingData && invoicingData.projectData">
     <mat-toolbar style="width:100%" color="secondary">
      {{(invoicingData.projectData.titol | slice:0:120)+"..."}}
      <div style="width:100%;float:right">
        <button matTooltip="{{ 'facturacio.toolbar.anarTreballToolTip' | translate }}" attr.aria-label="{{ 'facturacio.toolbar.anarTreballToolTip' | translate }}" matTooltipClass="tooltip-style" type="button" style="float: right; margin-left:10px;margin-right: 0" mat-icon-button (click)="this.goProject()">
           <mat-icon color="primary">assignment</mat-icon>
        </button>
        <button *ngIf="userInfo.rol != 1" mat-icon-button matTooltip="{{ 'facturacio.toolbar.exportarToolTip' | translate }}" attr.aria-label="{{ 'facturacio.toolbar.exportarToolTip' | translate }}" matTooltipClass="tooltip-style" (click)="this.export()" style="float: right; margin-left:10px;margin-right: 0">
           <mat-icon color="primary">assignment_returned</mat-icon>
        </button>
        <button *ngIf="userInfo.rol != 1" mat-icon-button (click)="addInvoice()" color="primary" matTooltip="{{ 'facturacio.toolbar.afegirToolTip' | translate }}" attr.aria-label="{{ 'facturacio.toolbar.afegirToolTip' | translate }}" matTooltipClass="tooltip-style" style="float: right; margin-left:10px;margin-right: 0">
           <mat-icon>note_add</mat-icon>
        </button>
     </div>
    </mat-toolbar>
    <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress" style="position: absolute;"></mat-progress-bar>
    <mat-card-content style="padding: 24px;">
      <h2 mat-line>{{ 'facturacio.titolDadesTreball' | translate }}</h2>
      <div class="dades-pressupost-import" style="background-color: #DDDDDD;padding:24px">
        <mat-form-field style="width: 80%">
         <input matInput placeholder="{{ 'facturacio.camps.nom' | translate }}" name="clau" disabled
        [value]="invoicingData.projectData.clau"
       />
        </mat-form-field> 
        <mat-form-field style="width: 15%;min-width:200px">
         <input matInput placeholder="{{ 'facturacio.camps.empresa' | translate }}" name="empresa" disabled
        [value]="invoicingData.projectData.empresa"
       />
        </mat-form-field> 
        <mat-form-field style="width: 100px">
         <input matInput placeholder="{{ 'facturacio.camps.pressupostTotal' | translate }}" name="pressupostTotal" disabled
          [value]="invoicingData.projectData.pressupostTotal | number:'1.0-2'"
         />
        </mat-form-field> 
        <mat-form-field style="width: 140px">
         <input matInput placeholder="{{ 'facturacio.camps.pressupostContractat' | translate }}" name="pressupostContractat" disabled
          [value]="invoicingData.projectData.pressupostContractat | number:'1.0-2'"
         />
        </mat-form-field> 
        <mat-form-field style="width: 100px">
         <input matInput placeholder="{{ 'facturacio.camps.impostos' | translate }}" name="importImpostos" disabled
          [value]="invoicingData.projectData.importImpostos | number:'1.0-2'"
         />
        </mat-form-field> 
        <mat-form-field style="width: 100px">
         <input matInput placeholder="{{ 'facturacio.camps.garantia' | translate }}" name="importGarantia" disabled
          [value]="invoicingData.projectData.pressupostGarantia | number:'1.0-2'"
         />
        </mat-form-field> 
      </div>
    <h2 mat-line style="float:left;clear:none;padding-top:20px">{{ 'facturacio.titolFacturacio' | translate }}</h2>
    <h4 style="padding-top:22px"><mat-checkbox style="margin-left: 1em;float:left;clear:none" name="follow" (change)="chgInvoices($event)" [checked]="esAjustComptable">{{ 'facturacio.ajustComptable' | translate }}</mat-checkbox></h4>
    <mat-form-field style="float:left;clear:left">
       <input matInput placeholder="{{ 'facturacio.acumulatFacturat' | translate }}" name="acumulatFacturat" disabled
          [value]="acumulat.facturat | number:'1.0-2'"
        />
    </mat-form-field>
    <mat-form-field style="float:left;clear:none">
     <input matInput placeholder="{{ 'facturacio.acumulatCobrat' | translate }}" name="acumulatCobrat" disabled
         [value]="acumulat.cobrat | number:'1.0-2'"
        />
    </mat-form-field>   
    <table>
      <thead>
        <tr style="text-align:right">
          <th>&nbsp;{{ 'facturacio.taula.colNumero' | translate }}</th>
          <th>{{ 'facturacio.taula.colDataFactura' | translate }}</th>
          <th>{{ 'facturacio.taula.colDataCobrament' | translate }}</th>
          <th mat-columnmat-numeric>{{ 'facturacio.taula.colFacturacioEur' | translate }}</th>
          <th mat-columnmat-numeric>{{ 'facturacio.taula.colFacturacioLocal' | translate }}</th>
          <th mat-columnmat-numeric>{{ 'facturacio.taula.colPercentPressupost' | translate }}</th>
          <th>{{ 'facturacio.taula.colActiva' | translate }}</th>          
          <th style="width:25%">{{ 'facturacio.taula.colObservacions' | translate }}</th>
          <th style="width:100px">{{ 'facturacio.taula.colAccions' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let invoice of invoicingData.invoices" style="text-align:right">
          <td>
            {{invoice.numero_factura}}
          </td>
          <td *ngIf="invoice.data_factura" title="{{ 'facturacio.titleDataFactura' | translate }}">
            {{invoice.data_factura | date}}
          </td>
          <td *ngIf="!invoice.data_factura" style="color:#FF0000" title="{{ 'facturacio.titleDataFacturaPrevista' | translate }}">
            {{invoice.data_factura_prevista | date}}
          </td>
          <td *ngIf="invoice.data_cobrament" title="{{ 'facturacio.titleDataCobrament' | translate }}">
            {{invoice.data_cobrament | date}}
          </td>
          <td *ngIf="!invoice.data_cobrament" style="color:#FF0000" title="{{ 'facturacio.titleDataCobramentPrevist' | translate }}">
            {{invoice.data_cobrament_prevista | date}}
          </td>
          <td>
            {{invoice.facturacio_prevista_eur | number:'1.0-2' }}
          </td>
          <td>
            {{invoice.facturacio_prevista_loc | number:'1.0-2' }}
          </td>
          <td>
            {{invoice.facturacio_prevista_percent | number:'1.0-2' }}
          </td>
          <td *ngIf="invoice.activa">
            <mat-icon>check_box</mat-icon>
          </td>
          <td *ngIf="!invoice.activa">
            <mat-icon>check_box_outline_blank</mat-icon>
          </td>
          <td>
            {{invoice.observacions }}
          </td>
          <td><!--2 admin, 3 normal 4 coordinador 1 visor -->
            <button *ngIf="userInfo.rol != 1" mat-icon-button title="{{ 'facturacio.editarTitle' | translate }}" color="primary" 
              (click)="editInvoice(invoice)" style="margin-right:-15px">
              <mat-icon>mode_edit</mat-icon>
            </button>
            <button *ngIf="userInfo.rol != 1" mat-icon-button title="{{ 'facturacio.esborrarTitle' | translate }}" color="primary"
              (click)="deleteInvoice(invoice)" style="margin-left:15px">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    </mat-card-content>
</mat-card>
